import { createContext } from 'react'

const authContext = createContext( {
  authenticated: false,
  accessToken: null,
  user: {},
  doLogin: () => {},
  logout: () => {}
} )

export const AuthProvider = authContext.Provider
export const AuthConsumer = authContext.Consumer


// WEBPACK FOOTER //
// ./src/contexts/auth.js